export enum BackgroundColor {
  primary = 'bg-primary',
  primaryDark = 'bg-primary-dark',
  primaryLight = 'bg-primary-light',
  brand = 'bg-brand',
  brandDark = 'bg-brand-dark',
  brandLight = 'bg-brand-light',
  secondary = 'bg-secondary',
  secondaryDark = 'bg-secondary-dark',
  secondaryLight = 'bg-secondary-light',
  white = 'bg-white',
  orange10 = 'bg-orange-10',
  orange20 = 'bg-orange-20',
  orange40 = 'bg-orange-40',
  orange50 = 'bg-orange-50',
  orange60 = 'bg-orange-60',
  grey10 = 'bg-grey-10',
  grey20 = 'bg-grey-20',
  grey30 = 'bg-grey-30',
  grey40 = 'bg-grey-40',
  grey50 = 'bg-grey-50',
  grey60 = 'bg-grey-60',
  grey70 = 'bg-grey-70',
  grey80 = 'bg-grey-80',
  grey90 = 'bg-grey-90',
  slate70 = 'bg-slate-70',
  slate80 = 'bg-slate-80',
  green10 = 'bg-green-10',
  green20 = 'bg-green-20',
  green50 = 'bg-green-50',
  green60 = 'bg-green-60',
  yellow10 = 'bg-yellow-10',
  yellow20 = 'bg-yellow-20',
  yellow50 = 'bg-yellow-50',
  yellow60 = 'bg-yellow-60',
  blue10 = 'bg-blue-10',
  blue20 = 'bg-blue-20',
  blue40 = 'bg-blue-40',
  blue50 = 'bg-blue-50',
  blue60 = 'bg-blue-60',
  blue80 = 'bg-blue-80',
  blue90 = 'bg-blue-90',
  red10 = 'bg-red-10',
  red20 = 'bg-red-20',
  red50 = 'bg-red-50',
  red60 = 'bg-red-60',
  destructive = 'bg-destructive',
}

export enum TextColor {
  primary = 'text-primary',
  primaryDark = 'text-primary-dark',
  primaryLight = 'text-primary-light',
  brand = 'text-brand',
  brandDark = 'text-brand-dark',
  brandLight = 'text-brand-light',
  secondary = 'text-secondary',
  secondaryDark = 'text-secondary-dark',
  secondaryLight = 'text-secondary-light',
  orange10 = 'text-orange-10',
  orange20 = 'text-orange-20',
  orange40 = 'text-orange-40',
  orange50 = 'text-orange-50',
  orange60 = 'text-orange-60',
  grey10 = 'text-grey-10',
  grey20 = 'text-grey-20',
  grey30 = 'text-grey-30',
  grey40 = 'text-grey-40',
  grey50 = 'text-grey-50',
  grey60 = 'text-grey-60',
  grey70 = 'text-grey-70',
  grey80 = 'text-grey-80',
  grey90 = 'text-grey-90',
  slate70 = 'text-slate-70',
  slate80 = 'text-slate-80',
  green10 = 'text-green-10',
  green20 = 'text-green-20',
  green50 = 'text-green-50',
  green60 = 'text-green-60',
  yellow10 = 'text-yellow-10',
  yellow20 = 'text-yellow-20',
  yellow50 = 'text-yellow-50',
  yellow60 = 'text-yellow-60',
  blue10 = 'text-blue-10',
  blue20 = 'text-blue-20',
  blue40 = 'text-blue-40',
  blue50 = 'text-blue-50',
  blue60 = 'text-blue-60',
  blue80 = 'text-blue-80',
  blue90 = 'text-blue-90',
  red10 = 'text-red-10',
  red20 = 'text-red-20',
  red50 = 'text-red-50',
  red60 = 'text-red-60',
  destructive = 'text-destructive',
}

export enum Color {
  primary = 'primary',
  primaryDark = 'primaryDark',
  primaryLight = 'primaryLight',
  brand = 'brand',
  brandDark = 'brandDark',
  brandLight = 'brandLight',
  secondary = 'secondary',
  secondaryDark = 'secondaryDark',
  secondaryLight = 'secondaryLight',
  orange10 = 'orange-10',
  orange20 = 'orange-20',
  orange40 = 'orange-40',
  orange50 = 'orange-50',
  orange60 = 'orange-60',
  grey10 = 'grey-10',
  grey20 = 'grey-20',
  grey30 = 'grey-30',
  grey40 = 'grey-40',
  grey50 = 'grey-50',
  grey60 = 'grey-60',
  grey70 = 'grey-70',
  grey80 = 'grey-80',
  grey90 = 'grey-90',
  slate70 = 'slate-70',
  slate80 = 'slate-80',
  green10 = 'green-10',
  green20 = 'green-20',
  green50 = 'green-50',
  green60 = 'green-60',
  yellow10 = 'yellow-10',
  yellow20 = 'yellow-20',
  yellow50 = 'yellow-50',
  yellow60 = 'yellow-60',
  blue10 = 'blue-10',
  blue20 = 'blue-20',
  blue40 = 'blue-40',
  blue50 = 'blue-50',
  blue60 = 'blue-60',
  blue80 = 'blue-80',
  blue90 = 'blue-90',
  red10 = 'red-10',
  red20 = 'red-20',
  red50 = 'red-50',
  red60 = 'red-60',
  destructive = 'destructive',
}

export const PRESET_COLORS = [
  {
    value: 'black',
    hex: '#000000',
  },
  {
    value: 'white',
    hex: '#FFFFFF',
  },
  {
    value: 'pink',
    hex: '#FFC0CB',
  },
  {
    value: 'red',
    hex: '#FF0000',
  },
  {
    value: 'yellow',
    hex: '#FFFF00',
  },
  {
    value: 'dark blue',
    hex: '#00008B',
  },
  {
    value: 'light blue',
    hex: '#ADD8E6',
  },
  {
    value: 'green',
    hex: '#008000',
  },
  {
    value: 'purple',
    hex: '#800080',
  },
  {
    value: 'orange',
    hex: '#FFA500',
  },
  {
    value: 'none',
    hex: 'transparent',
  },
];

// NOTE: white and yellow are considered bright colors because the default white text is difficult to read against them.
export const BRIGHT_COLORS = ['#FFFFFF', '#FFFF00', '#FFC0CB'];

// uses Euclidean distance method to calculate nearest preset-hex value from layer geojson rgba value;
// inspiration: https://nesin.io/blog/find-closest-color-javascript
export function getNearestPresetColor(rgba?: [number, number, number, number]) {
  if (!rgba) return '#000000';
  let closestColor: { value: string; hex: string } | undefined;
  let minDistance = Infinity;

  // convert rbga to rgb
  const [r, g, b, a] = rgba;
  const alpha = a / 255;
  const _r = Math.round((1 - alpha) * 255 + alpha * r);
  const _g = Math.round((1 - alpha) * 255 + alpha * g);
  const _b = Math.round((1 - alpha) * 255 + alpha * b);
  const rgb = [_r, _g, _b];

  for (const presetColor of PRESET_COLORS) {
    // hex to rgb for preset colors
    const presetHex = presetColor.hex;

    // extract hex substrings and convert to numbers
    // hexadecimals work best in base 16 rather than base 10 for their numeric system (per google)
    const hr = parseInt(presetHex.substring(1, 3), 16);
    const hg = parseInt(presetHex.substring(3, 5), 16);
    const hb = parseInt(presetHex.substring(5, 7), 16);

    // convert hex substrings to rgb values
    const hexRgb = [hr, hg, hb];

    // calculate distance to geojson rgb color
    const sumSquares = rgb.reduce((acc, cur, i) => acc + (cur - hexRgb[i]) ** 2, 0);
    const distance = Math.sqrt(sumSquares);

    // if we are near a preset color, use that preset color
    if (distance < minDistance) {
      minDistance = distance;
      closestColor = presetColor;
    }
  }

  // if no closest color, just return black
  if (!closestColor) return '#000000';

  return closestColor.hex;
}
